import dayjs from "dayjs";
import styles from "../MoveOutChecklist.module.css";
import { Calendar, Clock } from "react-feather";

const Badge = ({ type, children }) => {
    const cls = {
        blue: styles.badgeBlue,
        success: styles.badgeSuccess,
        warn: styles.badgeWarn,
        danger: styles.badgeDanger,
        muted: styles.badgeMuted,
    }[type] || styles.badgeMuted;
    return <span className={`${styles.badge} ${cls}`}>{children}</span>;
}

function InfoBox({ type, icon, children }) {
    const cls = { blue: styles.ibBlue, amber: styles.ibAmber, green: styles.ibGreen, red: styles.ibRed }[type];
    return (<div className={`${styles.ib} ${cls}`}>
        <i className={`ti ti-${icon}`} />
        <div>{children}</div>
    </div>);
}

const InspectionWaiting = ({ moveoutData, submitMoveoutChceckList }) => {

    const diffDays = dayjs(moveoutData.inspection_schedule_date).startOf("day").diff(dayjs().startOf("day"), "day");

    const simulateInspection = () => {
        let data = { current_step: 2, inspection_schedule_date: dayjs().format('YYYY-MM-DD'), inspection_date: dayjs().format('YYYY-MM-DD') };
        submitMoveoutChceckList(data);
    }

    return (<div className={`${styles.tp} ${styles.tpActive}`}>
        <div className={styles.waitWrap}>
            <div className={styles.waitIcon}>
                <Clock />
            </div>
            <div className={styles.waitTitle}>Waiting for Inspection Day</div>
            <div className={styles.waitSub}>Move-out flagged for {dayjs(moveoutData?.moveout_date).format('MMM DD, YYYY')}. Inspection scheduled for {dayjs(moveoutData?.inspection_schedule_date).format('MMM DD, YYYY')} —{" "}{diffDays} day{diffDays !== 1 ? "s" : ""} later. Come back on inspection day to complete the checklist and generate the final statement.</div>
            <div className={styles.daysPill}>
                <Calendar />
                {diffDays === 1 ? "Inspection tomorrow" : `Inspection in ${diffDays} days`}
            </div>
            <div className={styles.recapBox}>
                <div className={styles.recapBoxTitle}>Scheduled dates</div>
                <div className={styles.recapRow}>
                    <span style={{ color: "var(--text2)" }}>Move-out date</span>
                    <strong>{dayjs(moveoutData?.moveout_date).format('MMM DD, YYYY')}</strong>
                </div>
                <div className={styles.recapRow}>
                    <span style={{ color: "var(--text2)" }}>Inspection date</span>
                    <strong>{dayjs(moveoutData?.inspection_schedule_date).format('MMM DD, YYYY')}</strong>
                </div>
                <div className={styles.recapRow}>
                    <span style={{ color: "var(--text2)" }}>Days between</span>
                    <Badge type="warn">{diffDays} day{diffDays !== 1 ? "s" : ""}</Badge>
                </div>
            </div>
            <InfoBox type="amber" icon="alert-triangle" style={{ maxWidth: 440, margin: "0 auto 20px", textAlign: "left" }}>The <strong>final statement (credit or bill)</strong> is generated only after inspection is completed and the condition report is signed. Keys must be returned by move-out date.</InfoBox>
            <button className={styles.simBtn} onClick={(e) => simulateInspection()}>
                Simulate: Inspection day has arrived
            </button>
        </div>
    </div>);
};

export default InspectionWaiting;